import styled from "styled-components";

export const Contenedor=styled.div`
    Color: white;
`